// Conteúdo movido VERBATIM de context/DarkMode/index.js (Temas 2.0).
// ─── Paleta de referência ──────────────────────────────────────────────────────
export const KR = {
  brand:        "#F37021",
  brandSubtle:  "rgba(243,112,33,0.08)",
  brandHover:   "rgba(243,112,33,0.14)",

  // Status semântico
  connected:    "#10B981",
  pending:      "#F59E0B",
  closed:       "#94A3B8",
  error:        "#EF4444",
  transferred:  "#8B5CF6",

  // Superfícies light
  baseLight:    "#F1F5F9",
  surfaceLight: "#FFFFFF",
  borderLight:  "#E2E8F0",
  borderStrong: "#CBD5E1",

  // Texto light
  ink:          "#0F172A",
  inkSecond:    "#475569",
  inkMuted:     "#94A3B8",

  // Superfícies dark
  baseDark:     "#0D1117",
  surfaceDark:  "#161B22",
  surfaceDark2: "#1C2333",
  borderDark:   "rgba(255,255,255,0.08)",
  borderDark2:  "rgba(255,255,255,0.14)",

  // Texto dark
  inkDark:      "#E2E8F0",
  inkDarkSec:   "#94A3B8",
  inkDarkMuted: "#475569",
};

export const scrollbar = (thumb) => ({
  "&::-webkit-scrollbar":       { width: "6px", height: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: thumb,
    borderRadius: "3px",
  },
});

// ─── Componentes base (shared) ─────────────────────────────────────────────────
export const sharedComponents = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 6,
        textTransform: "none",
        fontWeight: 500,
        fontSize: "0.8125rem",
        letterSpacing: "0.01em",
      },
      containedPrimary: {
        boxShadow: "none",
        "&:hover": { boxShadow: "none" },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 4, fontWeight: 500, fontSize: "0.75rem" },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        borderRadius: 4,
        fontSize: "0.75rem",
        fontWeight: 500,
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: { borderRadius: 12 },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: { borderRadius: 8 },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: { borderRadius: 8 },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: { fontSize: "0.8125rem" },
      head: { fontWeight: 600, fontSize: "0.75rem", letterSpacing: "0.03em" },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: { fontSize: "0.875rem" },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: { fontSize: "0.875rem" },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: { fontSize: "0.875rem" },
    },
  },
};
